import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import "./home.css";
import MedicamentoCard from "../components/medicamentoCard";
import { getMedicamentos } from "../../services/api";

import buscar from "../../assets/buscar.png";
import mejorProducto from "../../assets/mejor_producto.png";
import precios from "../../assets/precios.png";
import alerta from "../../assets/alerta.png";

function pickRandomUnique(arr, n) {
  if (!Array.isArray(arr)) return [];
  if (arr.length <= n) return arr;

  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, n);
}

export default function Home() {
  // =========================
  // Destacados aleatorios
  // =========================
  const [allMeds, setAllMeds] = useState([]);
  const [destacados, setDestacados] = useState([]);
  const [medsStatus, setMedsStatus] = useState("idle"); // idle | loading | ok | error
  const [medsError, setMedsError] = useState("");

  const refreshRandom = useCallback(() => {
    setDestacados(pickRandomUnique(allMeds, 4)); 
  }, [allMeds]);

  useEffect(() => {
    let mounted = true;

    async function load() {
      setMedsStatus("loading");
      setMedsError("");
      try {
        const resp = await getMedicamentos(); 
        // tu API suele regresar { count, data }
        const data = resp?.data || resp || [];
        if (!mounted) return;

        setAllMeds(data);
        setDestacados(pickRandomUnique(data, 4));
        setMedsStatus("ok");
      } catch (e) {
        if (!mounted) return;
        setMedsStatus("error");
        setMedsError(e?.message || "No se pudieron cargar los medicamentos");
      }
    }

    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-overlay" />
        <div className="container hero-content">
          <h1>Encuentra el mejor precio para tus medicamentos</h1>
          <p className="hero-subtitle">
            Compara precios entre farmacias en línea y ahorra en tu tratamiento.
          </p>

          <div className="hero-actions">
            <Link to="/buscar" className="btn-primary">
              Buscar mi medicamento
            </Link>

            <div className="hero-secondary">
              <a href="#como-funciona" className="btn-link">
                ¿Cómo funciona RecoMeds?
              </a>
              <span className="dot">•</span>
              <a href="#como-ahorrar" className="btn-link">
                Ver algunos productos
              </a>
            </div>
          </div>

          <div className="trust-box">
            <p className="trust-title">
              RecoMeds ayuda a comparar precios de medicamentos entre distintas farmacias.
            </p>
            <p className="trust-text">
              La información se obtiene de forma automática y se presenta de manera clara para apoyar
              la toma de decisiones y facilitar el ahorro.
            </p>
          </div>
        </div>
      </section>

      <section id="como-funciona" className="info">
        <div className="container">
          <h2>¿Cómo funciona RecoMeds?</h2>
          <p className="info-subtitle">
            En pocos pasos, RecoMeds muestra opciones de compra y ayuda a elegir la alternativa más conveniente.
          </p>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Busca tu medicamento</h3>
              <p>Realiza la búsqueda por nombre o por sustancia activa.</p>
              <div className="step-icon">
                <img src={buscar} alt="Buscar" />
              </div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <h3>Compara precios</h3>
              <p>Se muestran opciones disponibles en distintas farmacias en línea.</p>
              <div className="step-icon">
                <img src={precios} alt="Precios" />
              </div>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <h3>Elige la mejor opción</h3>
              <p>Se priorizan alternativas con el mismo principio activo y menor precio.</p>
              <div className="step-icon">
                <img src={mejorProducto} alt="Mejor Producto" />
              </div>
            </div>

            <div className="step">
              <div className="step-number">4</div>
              <h3>Activa alertas</h3>
              <p>Recibe notificaciones si el precio baja o cambia.</p>
              <div className="step-icon">
                <img src={alerta} alt="Alerta" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="como-ahorrar" className="info alt">
        <div className="container">
          <h2>¿Cómo puede ayudar a ahorrar?</h2>
          <div className="tips">
            <div className="tip">
              <h3>Comparación directa</h3>
              <p>Permite identificar diferencias de precio entre farmacias sin buscar manualmente.</p>
            </div>
            <div className="tip">
              <h3>Recomendación por sustancia activa</h3>
              <p>Propone opciones equivalentes cuando existen presentaciones con mejor precio.</p>
            </div>
            <div className="tip">
              <h3>Alertas de variación</h3>
              <p>Ayuda a comprar en el momento más conveniente cuando el precio baja.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="destacados">
        <div className="container">
          <div className="section-header">
            <h2>Medicamentos destacados</h2>

            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                className="btn-random"
                onClick={refreshRandom}
                disabled={medsStatus !== "ok" || allMeds.length === 0}
                style={{ cursor: medsStatus === "ok" ? "pointer" : "not-allowed" }}
              >
                Ver otros
              </button>

              <Link to="/buscar" className="btn-ghost">
                Ver todos
              </Link>
            </div>
          </div>

          {medsStatus === "loading" && (
            <p style={{ marginTop: 10 }}>Cargando medicamentos destacados…</p>
          )}

          {medsStatus === "error" && (
            <p style={{ marginTop: 10 }}>
              Ocurrió un error cargando medicamentos: {medsError}
            </p>
          )}

          {medsStatus === "ok" && (
            <div className="grid-cards">
              {destacados.map((m) => (
                <MedicamentoCard
                  key={m._id || m.enlace || m.nombre}
                  medicamento={m}      
                  favoritoId={m._id}
                />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
